import { ActivityPathId } from '@/api/models/aggregate'
import { FrontActivityPart } from '@/store/slices/aggregateSlice/types/FrontActivityPart.type'
import { FrontActivityWithAggregate } from '@/store/slices/aggregateSlice/types/FrontActivityWithAggregate.type'
import { findActivityPartsFlattenParentsByActivityPathId } from './findActivityPartsFlattenParentsByActivityPathId'

// @todo check usage of me
export const findActivityPartByActivityPathId = (
  activityWithAggregates: FrontActivityWithAggregate,
  activityPathId: ActivityPathId,
): FrontActivityPart<FrontActivityWithAggregate> => {
  return findActivityPartsFlattenParentsByActivityPathId(activityWithAggregates, activityPathId).pop()!
}
